import styled, { css } from "styled-components"

export default {
    "FilterElement": styled.div`
        display: flex;
        flex-direction: column;
        gap: 8px;

        & > h2 {
            ${({ theme }) => theme.font["medium-semibold"]};
        }
    `,
    "ElementList": styled.div`
        display: flex;
        flex-wrap: wrap;
        gap: 4px;
    `,
    "Element": styled.button`
        flex-basis: 93px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        ${({ theme }) => theme.font["small-medium"]};
        color: ${({ theme }) => theme.color["grey3"]};
        border: 1px solid ${({ theme }) => theme.color["grey2"]};
        border-radius: 4px;
        
        ${({ $active }) => $active && css`
            color: ${({ theme }) => theme.color["black"]};
            border: 1px solid ${({ theme }) => theme.color["black"]};
        `}
    `,
    "DurationList": styled.div`
        display: flex;
        align-items: center;
        gap: 2px;

        & > p {
            ${({ theme }) => theme.font["small-medium"]};
        }
    `,
    "Duration": styled.button`
        width: 100%;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid ${({ theme }) => theme.color["black"]};
        border-radius: 4px;
    `,
    "DateList": styled.div`
        display: flex;
        flex-direction: column;
        margin-top: 24px;
    `,
    "DateDiv": styled.div`
        height: 32px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 56px;
        background-color: ${({ theme, $highlight }) => $highlight && theme.color["grey1"]};

        & > p {
            min-width: 36px;
            text-align: end;
            ${({ theme }) => theme.font["large-medium"]};
            color: ${({ theme, $highlight }) => $highlight ? theme.color["black"] : theme.color["grey3"]};
        }
    `,
    "ScrollList": styled.div`
        display: flex;
        flex-direction: column;
        gap: 8px;
        max-height: 200px;
        overflow-y: auto;
    `,
    "ScrollContent": styled.div`
        display: flex;
        flex-direction: column;
        gap: 4px;
    `,
    "SelectElement": styled.button`
        width: 100%;
        padding: 8px 12px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        ${({ theme }) => theme.font["small-medium"]};
        color: ${({ theme }) => theme.color["grey3"]};
        border: 1px solid ${({ theme }) => theme.color["grey2"]};
        border-radius: 4px;

        ${({ $active }) => $active && css`
            color: ${({ theme }) => theme.color["black"]};
            border: 1px solid ${({ theme }) => theme.color["black"]};
        `}
    `,

    "Option": styled.p`
        ${({ theme }) => theme.font["xsmall-medium"]};
    `,
}